//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  queryBatchSingleEnrollConfig,
  queryNotice,
} from '@/https/prepareEnroll'

export default {

  data () {
    return {
      enrollNotice: '',
      emptyMsg: '暂无配置报名须知',
      loading: false,
    }
  },

  async created () {
    await this.setNotice()
    await this.$nextTick()
    this.$refs.countDownBtn.countDown()
  },

  methods: {
    async setNotice () {
      this.loading = true
      const { data, message } = await queryNotice({ pcdm: this.$route.query.pcdm })
      this.enrollNotice = data || ''
      this.emptyMsg = message

      if (!this.enrollNotice?.length) {
        this.nextStep()
      }

      this.loading = false
    },

    async nextStep () {
      const { data } = await queryBatchSingleEnrollConfig()

      if (+data === 1) {
        this.$router.push({
          path: '/startPrepareEnroll',
          query: { ...this.$route.query },
        })
      } else {
        this.$router.push({
          path: '/choosePrepareEnrollType',
          query: { ...this.$route.query },
        })
      }
    },
  },
}
